export const errorPages = {
    'noCoin.info.title': 'Sorry!',
    'noCoin.info.text': ` We don't have available data about this cryptocurrency. Please go to home page
    and try another one.`,
    'noCoin.info.linkText': 'Go to home page',
    'loading.label': 'Loading',
}